var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2822_26467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.20288,
    y: 1.20282,
    width: 21.5943,
    height: 21.5943,
    rx: 2.25,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.593506 7.11542H23.2654",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07945 15.5778C8.07945 15.5778 7.33625 15.5778 6.78858 14.7563C6.43759 14.2298 6.53647 12.9804 6.65276 12.1508C6.71833 11.6831 7.12637 11.353 7.59868 11.353H8.53574C9.01903 11.353 9.43316 11.6983 9.48999 12.1783C9.58821 13.0077 9.66786 14.2356 9.37032 14.7563C8.90091 15.5778 8.07945 15.5778 8.07945 15.5778ZM8.07945 15.5778L8.07943 18.0422M6.55384 18.0422H8.07943M9.48767 18.0422H8.07943",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.2379,
    cy: 14.639,
    r: 2.77062,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.25401,
    cy: 4.19779,
    r: 0.84507,
    fill: "#BF9A6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7459,
    cy: 4.19779,
    r: 0.84507,
    fill: "#BF9A6D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.2116,
    y: 3.77526,
    width: 5.57746,
    height: 0.84507,
    rx: 0.422535,
    stroke: "#BF9A6D",
    strokeWidth: 0.84507
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2822_26467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.e6d56e5e244eb3e3c5bb8eb553ed8806.svg";
export { ForwardRef as ReactComponent };